export class Utils {
  public static replaceDiacritics(text: string, lowerCase = true): string {
    const withoutDiacritics = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return lowerCase ? withoutDiacritics.toLowerCase() : withoutDiacritics;
  }

  // TODO this doesn't feel like it's the correct way to do this. Research and redo.
  public static removeUnicode(text: string): string {
    return this.unicodeToChar(text.replace(/&#(.*?);/g, '\\u$1'));
  }

  public static unicodeToChar(text) {
    return text.replace(/\\u[\dA-F]{4}/gi,
      (match) => {
        return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 10));
      });
  }
}
